import { OTPField } from '@base-ui/react/otp-field';
import { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

export interface OtpFieldProps {
  id?: string;
  length?: number;
  value?: string;
  onValueChange?: (value: string) => void;
  disabled?: boolean;
  autoSubmit?: boolean;
  invalid?: boolean;
  className?: string;
  'aria-describedby'?: string;
}

const slotClassName = twMerge(
  'h-12 w-10 shrink-0 border-2 bg-white text-center text-2xl font-medium font-mono text-content-default outline-none',
  'border-border-default focus:relative focus:z-10 focus:border-border-active',
  'data-[invalid]:border-misc-error',
  'data-[disabled]:cursor-not-allowed data-[disabled]:bg-bluegray-50 data-[disabled]:opacity-60'
);

const OtpField = forwardRef<HTMLInputElement, OtpFieldProps>(
  (
    {
      id,
      length = 6,
      value,
      onValueChange,
      disabled = false,
      autoSubmit = false,
      invalid = false,
      className,
      'aria-describedby': ariaDescribedBy
    },
    ref
  ) => (
    <OTPField.Root
      length={length}
      value={value}
      onValueChange={onValueChange}
      disabled={disabled}
      autoSubmit={autoSubmit}
      validationType="numeric"
      className={twMerge('flex gap-2', className)}
    >
      {Array.from({ length }, (_, index) => (
        <OTPField.Input
          key={index}
          ref={index === 0 ? ref : undefined}
          id={index === 0 ? id : undefined}
          aria-invalid={invalid || undefined}
          aria-describedby={ariaDescribedBy}
          aria-label={index === 0 ? undefined : `Digit ${index + 1} of ${length}`}
          className={twMerge(slotClassName, invalid && 'border-misc-error')}
        />
      ))}
    </OTPField.Root>
  )
);

OtpField.displayName = 'OtpField';

export default OtpField;
